import {
    RaikoButtonPrimary, RaikoFlexAlignEnd,
    RaikoGridOneColumn,
    RaikoMaterialOutlinedInput,
    RaikoNumberInputOutlined, RaikoToggleOutlined, showErrorMessage, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {useState} from "react";
import {css} from "@emotion/css";
import {GroupsService} from "../../serverService/groups/GroupsService";
import {useAuthState} from "../../context/AuthContext";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export default function AddNewGroup(
    {
        handleAddNewItemToTable
    }) {


    const service = new GroupsService()

    const {fundID} = useAuthState()

    const [groupName, setGroupName] = useState("")
    const [groupCode, setGroupCode] = useState("");
    const [enabled, setEnabled] = useState(true);

    const [loading, setLoading] = useState(false);

    function checkFields() {
        let message = ""
        let state = false

        if (groupCode.length === 0)
            message = "لطفا کد گروه را به درستی وارد نمایید."
        else if (groupName.length === 0)
            message = "لطفا نام گروه را به درستی وارد نمایید."
        else
            state = true

        if (message && message.length > 0)
            showWarningMessage(message)

        return state
    }

    function handleAddNewItem() {
        if (checkFields()) {
            setLoading(true)
            service.createNewGroup(
                fundID,
                groupCode, groupName, enabled
            ).then(response => {
                showSuccessMessage("گروه جدید با موفقیت افزوده شد.")
                handleAddNewItemToTable(response)
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                setLoading(false)
            })
        }
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>
            <RaikoNumberInputOutlined
                labelText={"کد گروه"}
                value={groupCode}
                setValue={setGroupCode}
            />
            <RaikoMaterialOutlinedInput
                labelText={"نام گروه"}
                value={groupName}
                setValue={setGroupName}
            />
            <RaikoToggleOutlined
                checked={enabled}
                setChecked={setEnabled}
                labelText={"فعالسازی/غیرفعالسازی"}
            />

            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary
                    label={"افزودن"}
                    onClick={handleAddNewItem}
                    loading={loading}
                />
            </RaikoFlexAlignEnd>
        </RaikoGridOneColumn>
    )
}
